import './assets/form-item.css';const e = {
  "form-item": "_form-item_uoq9e_1",
  "form-item--has-hidden-labels": "_form-item--has-hidden-labels_uoq9e_8",
  "form-item--margin-bottom": "_form-item--margin-bottom_uoq9e_12",
  "form-item__label": "_form-item__label_uoq9e_16",
  "form-item__description": "_form-item__description_uoq9e_17",
  "form-item__error": "_form-item__error_uoq9e_33",
  "form-item__error-message": "_form-item__error-message_uoq9e_45",
  "form-item__error-icon": "_form-item__error-icon_uoq9e_54"
};
export {
  e as s
};
